import { createPortal } from 'react-dom';

import { WindowLevelIndicator } from './window-level-indicator';

import { useViewportSlots } from '@/hooks/use-viewport-slots';
import { isCprViewport, respondsToWindowLevel } from '@/visualization/viewports/viewport-categories';

/**
 * Bridge component that renders a WindowLevelIndicator into the top-left 'wl'
 * slot of every W/L-capable viewport via React portals.
 *
 * Place as a sibling of ViewportContainer within the VisualizationProvider tree.
 */
export function WindowLevelIndicatorManager() {
    const viewports = useViewportSlots(['wl']);

    const targets = viewports.filter(
        (vp) => vp.slotKind === 'viewport' && vp.slots.wl !== undefined && respondsToWindowLevel(vp.type)
    );

    if (targets.length === 0) return null;

    return (
        <>
            {targets.map((vp) =>
                createPortal(
                    <WindowLevelIndicator key={vp.id} clearTopSlider={isCprViewport(vp.type)} />,
                    vp.slots.wl!,
                    `viewport-wl-${vp.id}`
                )
            )}
        </>
    );
}
